// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import Morty from '../data/Morty';


import Avatar from '@mui/material/Avatar';


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIos';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockClosedIcon from '@mui/icons-material/LockOutlined';
import HomeIcon from '@mui/icons-material/Home';

const HOME_URL = "/home";

function ButtonSetPassword(props) {
    const [hover,setHover] = useState(false);
    
    return (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          id="submitButton"
          onMouseOver={() => setHover(true) }
          onMouseOut={() => setHover(false) }
          endIcon={hover ? <LockClosedIcon /> : <LockOpenIcon /> }
        >
          Update Password
        </Button>
    );
}

class PasswordChange extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            saved: false,
            saving: false,
            send_to: HOME_URL,
            errors: [],
            passwordCurrent: '',
            passwordConfirm: '',            
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);        
    }
    
    
    isPasswordValid() {
        
        if(this.state.passwordCurrent != this.state.passwordConfirm) {
            this.setState({ errors: ['Passwords do not match',
                                     'Please ensure that you typed both passwords correctly'] });
            return false;            
        }
        if(this.state.passwordCurrent.length < 8) {
            this.setState({ errors: ['Password is too short',
                                     'The password must be at least 8 characters'] });
            return false;            
        }
        if(this.state.passwordCurrent.length > 128) {
            this.setState({ errors: ['Passwords is too big',
                                     'The password cannot be more than 128 characters'] });
            return false;            
        }        
        
        return true;
    }
    
    handleSubmit(e) {
        e.preventDefault();

        if(this.isPasswordValid()) {
            let payload = { password: this.state.passwordCurrent,
                            key: this.props.token.key,
                            uuid: this.props.token.uuid };

            let self = this;
	        Morty.post('/morty/auth/password/change/', payload )
                .then((data) => {
                    self.setState({ saved: true });
                    console.log("Password updated, data", data);
                    if(data.send_to)
                        self.setState({ send_to: data.send_to });
                    
                    if(self.props && self.props.onSuccess)
                        self.props.onSuccess();
                });
            
        }
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }    
    
    render() {

        /* if we don't have a valid token, just get out of here */
        if(!this.props.token || this.props.token === undefined) {
            // FIXME: this is pretty un-graceful
            window.location.href='/password/reset?msg=Link+expired,+confirm+your+email+again.';            
        }
        
        const classes = {
            errors:{
                h2: { color: "#9B0202",
                      textAlign: "left",
                      marginBottom: 0,
                    },
                h3: { color: "#9B0202",
                      textAlign: "left" },                
            }
        };
        

        let errors = null;
        if(this.state.errors.length) {
            errors = (<div >
                        <h2 style={classes.errors.h2}>{ this.state.errors[0] }</h2>
                        <h3 style={classes.errors.h3}>{ this.state.errors[1] }</h3>
                      </div>);
        }


        if(this.state.saved) {
            let icon = <HomeIcon />;
            let txt = "Go Home";
            if (this.state.send_to != HOME_URL) {
                txt = "Continue";
                icon = <ArrowForwardIcon />;
            }
            
            return (
                <div className="center-text">
                  <CheckCircleIcon  style={{ color: "#56c98d", fontSize: "127" }} />
                  <h2>Your password has been updated!</h2>
                  <Box>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      id="submitButton"
                      onClick={() => { window.location.href=this.state.send_to; }}
                      endIcon={icon}
                    >{ txt }</Button>                    
                  </Box>
                  
                </div>
            );
        }
        else {
            return (
		          <form onSubmit={this.handleSubmit} noValidate>
                    {errors}
                    
                    <TextField
                      onChange={this.handleChange}
                      value={this.state.passwordCurrent}
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="passwordCurrent"
                      label="Password"
                      type="password"
                      id="passwordCurrent"
                      autoComplete="current-password"
                    />
                    
                    <TextField
                      onChange={this.handleChange}
                      value={this.state.passwordConfirm}                
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="passwordConfirm"
                      label="Password (confirm)"
                      type="password"
                      id="passwordConfirm"
                    />
                    
                    <ButtonSetPassword />
                    
                  </form>

	        );
        }
    }

}

export default PasswordChange;
